// src/modules/app-views/toolbox/pages/Document/tabs/ReferencesTab/components/SearchTermsCard.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Card, Col, Row } from 'antd';
import { ROW_GUTTER } from 'constants/ThemeConstant';
import translateX from 'utils/translateX';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const SearchTermsCard = () => {
  // ---------------------------------------------------------------------------
  // 8. UI
  // ---------------------------------------------------------------------------
  return (
    <Card title={<div className="text-muted">{translateX('search_terms')}</div>}>
      <Row gutter={ROW_GUTTER}>
        <Col xs={24}>
          <SimpleSelect
            name="searchTerms"
            label="search_terms"
            mode="tags"
            allowClear
          />
        </Col>
      </Row>
    </Card>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SearchTermsCard;

// *******************************************************************************
// HELPERS
// *******************************************************************************
